import {isEmpty} from 'lodash'
export function getAuthorColumns() {
    let columns = JSON.parse(localStorage.getItem('authorColumns'))
    if (!isEmpty(columns)) {
        return columns
    }
    return ['checkbox','_id', 'first_name', 'middle_name', 'last_name', 'publications', 'admin', 'short_description', 'biography', 'city', 'country', 'article_count', 'publication_count', 'settings']
}

export function getAuthorTableOptions() {
    return {
        filterByColumn: false,
        perPage:10,
        pagination: { show: false},
        filterable: false,
        headings: {
            _id: 'GUID',
            first_name : 'first Name',
            middle_name: 'Middle Name',
            last_name : 'Last Name',
            publications: 'Publications',
            admin: 'Admin',
            short_description: 'short Description',
            city: 'City',
            country: 'Country',
            publication_count: 'Publication Count',
            article_count: 'Article Count',
          },
          sortable: ['no'],
          sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesorting' },
    }
}
export function getAuthorTableSettingsOptions() {
    return [
           {key: 'checkbox', value: ('Checkbox') },
           {key: '_id', value: ('GUID')},
           {key: 'first_name', value: ('First Name')},
           {key: 'last_name', value: ('Last Name')},
           {key: 'middle_name', value: ('Middle Name')},
           {key: 'publications', value: ('Publications')},
           {key: 'admin', value: ('Admin')},
           {key: 'short_description', value: ('Short Description')},
           {key: 'biography', value: ('Biography')},
           {key: 'city', value: ('City')},
           {key: 'country', value: ('Country')},
           {key: 'publication_count', value: ('Publication Count')},
           {key: 'article_count', value: ('Article Count')},
           {key: 'settings', value: ('Settings')},
    ]
}